<template>
  <div class="body1">
    <div class="content">
      <p class="tit-p">INVEST IN A <br>WORTHWHILE<br>BUSINESS</p>
      <!-- <div class="title1 title large bold">Franchise</div>
      <div class="title">WHAT ARE THE TYPE OF FRANCHISE MODELS？</div>
      <div class="items">
        <div class="item">
          <img class="img" src="../../assets/franchise-01.png">
          <div class="name">Single Unit<br/>Franchise</div>
        </div>
        <div class="item">
          <img class="img"  src="../../assets/franchise-02.png">
          <div class="name">Multi-Unit<br/>Franchise</div>
        </div>
        <div class="item">
          <img class="img"  src="../../assets/franchise-03.png">
          <div class="name">Master<br/>Franchise</div>
        </div>
        <div class="item">
          <img class="img"  src="../../assets/franchise-04.png">
          <div class="name">Curriculum<br/>licensing</div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped lang="less">
@import "../../assets/style/index";
.body1{
  height: 726px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: url("../../assets/franchise-01-bg.png") no-repeat center;
  background-size: cover;
  .content{
    .media-content;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .tit-p{
      color: #FFFFFF;
      font-size: 56px;
      line-height: 66px;
      margin-top: 210px;
    }
    .items{
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      height: 100%;
      .item{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 30px;
        .img{
          height: 108px;
          width: 108px;
        }
        .name{
          font-size: 20px;
          font-weight: bold;
          color: white;
          margin-left: 14px;
        }
      }
    }
    .title1{
      margin-top: 100px;
    }
    .title{
      width: 100%;
      text-align: left;
      color: white;
      font-size: 18px;
      line-height: 30px;
    }
    .large{
      font-size: 30px;
    }
    .bold{
      font-weight: bold;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/franchise/e-body1.vue